﻿package com.mgacreative.hotelru.feature.inventory.di

import com.mgacreative.hotelru.feature.inventory.ui.InventoryViewModel
import com.mgacreative.hotelru.feature.inventory.ui.PurchasingViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getInventoryFeatureModule() = module {
    viewModel { InventoryViewModel(get()) }
    viewModel { PurchasingViewModel(get(), get(), getOrNull()) }
}

